"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionSummary = exports.AccordionDetails = exports.AccordionActions = exports.Accordion = void 0;
var _Icon = require("../Icon");
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionActions = _interopRequireDefault(require("@mui/material/AccordionActions"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"],
  _excluded2 = ["expandIcon", "ariaControls", "id"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCyAccordion = "Accordion";
var dataCyAccordionSummary = "AccordionSummary";
var dataCyAccordionDetails = "AccordionDetails";
var dataCyAccordionActions = "AccordionActions";
// test
var Accordion = exports.Accordion = function Accordion(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion["default"], _objectSpread(_objectSpread({
    "data-cy": dataCyAccordion
  }, props), {}, {
    children: children
  }));
};
var AccordionSummary = exports.AccordionSummary = function AccordionSummary(_ref2) {
  var _ref2$expandIcon = _ref2.expandIcon,
    expandIcon = _ref2$expandIcon === void 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ExpandMoreIcon, {
      fontSize: "small"
    }) : _ref2$expandIcon,
    _ref2$ariaControls = _ref2.ariaControls,
    ariaControls = _ref2$ariaControls === void 0 ? "accordion-content" : _ref2$ariaControls,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? "accordion-header" : _ref2$id,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionSummary["default"], _objectSpread({
    "data-cy": dataCyAccordionSummary,
    expandIcon: expandIcon,
    "data-cy-controls": ariaControls,
    id: id
  }, props));
};
var AccordionDetails = exports.AccordionDetails = function AccordionDetails(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionDetails["default"], _objectSpread({
    "data-cy": dataCyAccordionDetails
  }, props));
};
AccordionDetails.propTypes = {
  classes: _propTypes["default"].object,
  children: _propTypes["default"].node
};
AccordionSummary.propTypes = {
  /**
   * The content of the accordion summary.
   */
  children: _propTypes["default"].node,
  /**
   * 	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes["default"].node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the CSS :focus-visible selector.
   * The rationale for using this feature is explained here.
   * A polyfill can be used to apply a focus-visible class to other components if needed.
   */
  focusVisibleClassName: _propTypes["default"].string,
  /**
   * Props applied to the IconButton element wrapping the expand icon.
   */
  IconButtonProps: _propTypes["default"].object
};
var AccordionActions = exports.AccordionActions = function AccordionActions(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionActions["default"], _objectSpread({
    "data-cy": dataCyAccordionActions
  }, props));
};